import React from 'react';
import classNames from 'classnames';
import { Switch, Case, Default } from 'react-if';

import Touchable from '@components/touchable';

import styles from './hoverable-block.module.scss';

type Props = {
  block?: boolean;
  children: React.ReactNode;
  className?: string;
  isOpaque?: boolean;
  onClick?: () => void;
  to?: string;
  wide?: boolean;
};

const HoverableBlock = React.forwardRef<HTMLDivElement, Props>(
  (
    {
      block = false,
      children,
      className,
      isOpaque = false,
      onClick,
      to,
      wide = true,
    },
    ref,
  ) => {
    const classnames = classNames(styles.container, {
      [styles['container--actionable']]: !!onClick || !!to,
      [styles['container--wide']]: wide,
      [styles['container--opaque']]: isOpaque,
    });

    return (
      <div className={className} ref={ref}>
        <Switch>
          <Case condition={to}>
            <Touchable
              block={block}
              href={to}
              onClick={onClick}
              className={classnames}
            >
              {children}
            </Touchable>
          </Case>
          <Case condition={!!onClick}>
            <div
              role="button"
              tabIndex={0}
              className={classnames}
              onClick={onClick}
              onKeyPress={onClick}
            >
              {children}
            </div>
          </Case>
          <Default>
            <div className={classnames}>{children}</div>
          </Default>
        </Switch>
      </div>
    );
  },
);

HoverableBlock.displayName = 'HoverableBlock';

export default HoverableBlock;
